<div class="background">
    <div class="inset">
      <div >
        <h1 class="">{{config?.congrats}}</h1>
        <div class="horizontalLine"></div>
        <p class="">{{config?.congratsBody}}</p>
        <div class="center">
          <button  class="buttonConfig transition" (click)="gotoMyLessons()" >{{config?.navMyGuides}}</button>
          <button  class="buttonConfig transition" (click)="gotoContactUs()" >{{config?.navContactUs}}</button>
      </div>
      </div>
    </div>
  </div>